(() => {
  const selector = '.jdgm-cards-carousel[data-widget="cards-carousel"]';
  const mobile = matchMedia('(max-width: 749px)');
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const getCarousel = event => mobile.matches && event.target.closest(selector);
  const getTrack = root => root.querySelector('.jdgm-cards-wrapper > .jdgm-videos-container');

  function prepare(root) {
    const track = getTrack(root);
    if (!track) return;
    track.tabIndex = mobile.matches ? 0 : -1;
    track.setAttribute('role', 'region');
    track.setAttribute('aria-label', root.querySelector('.jdgm-title')?.textContent || 'Reviews');
  }

  function scroll(root, direction) {
    const track = getTrack(root);
    const card = track?.querySelector('.jdgm-card:not([data-clone-type])');
    if (!card) return;
    const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
    const max = track.scrollWidth - track.clientWidth;
    const left = direction > 0 && track.scrollLeft >= max - 1 ? 0
      : direction < 0 && track.scrollLeft <= 1 ? max : track.scrollLeft + direction * step;
    track.scrollTo({ left, behavior: motion.matches ? 'instant' : 'smooth' });
  }

  document.addEventListener('click', event => {
    const root = getCarousel(event);
    const arrow = event.target.closest('.jdgm-arrow');
    if (!root || !arrow || !getTrack(root)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    scroll(root, (arrow.getAttribute('onclick') || '').includes('Previous') ? -1 : 1);
  }, true);

  for (const name of ['touchstart', 'touchmove', 'touchend', 'pointerdown', 'pointermove', 'pointerup']) {
    document.addEventListener(name, event => {
      const root = getCarousel(event);
      if (!root || !event.target.closest('.jdgm-videos-container')) return;
      prepare(root);
      event.stopImmediatePropagation();
    }, { capture: true, passive: true });
  }

  document.addEventListener('keydown', event => {
    const root = getCarousel(event);
    if (!root || event.target !== getTrack(root)) return;
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    scroll(root, event.key === 'ArrowLeft' ? -1 : 1);
  }, true);

  const refresh = () => document.querySelectorAll(selector).forEach(prepare);
  refresh();
  window.addEventListener('load', refresh, { once: true });
  document.addEventListener('shopify:section:load', refresh);
  mobile.addEventListener('change', () => {
    document.querySelectorAll(selector).forEach(root => {
      const track = getTrack(root);
      if (track && !mobile.matches) track.scrollLeft = 0;
      prepare(root);
    });
  });
  // Observe only the app's own empty carousel mount, then disconnect after lazy rendering.
  document.querySelectorAll(selector).forEach(root => {
    if (getTrack(root)) return;
    const observer = new MutationObserver(() => {
      if (!getTrack(root)) return;
      prepare(root);
      observer.disconnect();
    });
    observer.observe(root, { childList: true, subtree: true });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) observer.disconnect();
    }, { once: true });
  });
})();
